import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-2" }
const _hoisted_2 = { class: "uppercase" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex flex-wrap" }
const _hoisted_5 = { class: "flex flex-wrap space-x-2" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center text-blue"
}
const _hoisted_7 = {
  key: 1,
  class: "flex items-center text-blue"
}
const _hoisted_8 = {
  key: 0,
  class: "flex items-center text-blue"
}
const _hoisted_9 = {
  key: 1,
  class: "flex items-center text-blue"
}
const _hoisted_10 = {
  key: 0,
  class: "flex flex-wrap items-center space-x-4 text-blue"
}

import { PropType, computed } from "vue";
import { Event } from "@/types";

import DefaultButton from "../DefaultButton.vue";
import RoleGuard from "../RoleGuard.vue";

import { User } from "@/types/User";
import { useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventStatusSwitch',
  props: {
  event: {
    type: Object as PropType<Event>,
    required: true,
  },
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  emits: ["change", "cancel"],
  setup(__props, { emit: emits }) {

const props = __props;

const { userIsAdmin } = useUserStore();




/** Shows the Status Bar if the user is an admin or related to the Event.
 *  i.e is the creator, or the trainer.
 */
const canUserSeeStatusBar = computed(() => {
  if (userIsAdmin) {
    return true;
  }

  if (props.event.user_id === props.user.id || props.event.user_id === props.user.id) {
    return true;
  }

  return false;
});

const endStatuses = ["cancelled", "completed"];

const type = computed(() => {
  let c = "";

  switch (props.event.status) {
    case "draft":
      c = "bg-alert-secondary border-[#D3D6D8]";
      break;
    case "in review":
      c = "bg-alert-secondary border-[#D3D6D8]";
      break;
    case "published":
      c = "bg-alert-success border-alert-success-600";
      break;
    case "unpublished":
      c = "bg-alert-secondary border-[#D3D6D8]";
      break;
    case "confirmed":
      c = "bg-blue-200 border-blue-400";
      break;
    case "cancelled":
      c = "bg-red-200 border-red-400";
      break;
  }

  return c;
});

function dateStringToLocal(dateStr: string): string {
  const dateOnly = dateStr.split("T")[0];
  const [year, month, day] = dateOnly.split("-").map(Number);
  return new Date(year, month - 1, day, 12, 0, 0).toDateString();
}

async function emitEventChange(status: string) {
  return emits("change", status);
}

async function emitCancel() {
  return emits("cancel");
}

return (_ctx: any,_cache: any) => {
  return (_unref(canUserSeeStatusBar))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_unref(type), 'flex flex-wrap space-y-4 md:space-y-0 items-center p-4 justify-between border rounded text-alert-secondary-600'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("this-event-is")) + " ", 1),
            _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.$t(`${__props.event.status}`)), 1),
            _createTextVNode(". "),
            (__props.event.publish_at && !endStatuses.includes(__props.event.status))
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "This event will be published to the website on " + _toDisplayString(dateStringToLocal(__props.event.publish_at)), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(RoleGuard, { roles: ['admin', 'courses-admin'] }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                (__props.event.status !== 'published' && !endStatuses.includes(__props.event.status))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(DefaultButton, {
                        type: "primary",
                        onAction: _cache[0] || (_cache[0] = ($event: any) => (emitEventChange('confirmed')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("confirm-event")), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (__props.event.status === 'confirmed')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(DefaultButton, {
                        type: "primary",
                        onAction: _cache[1] || (_cache[1] = ($event: any) => (emitEventChange('published')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("publish-event")), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(RoleGuard, { roles: ['l4a-trainer', 'trainer-organisation'] }, {
            default: _withCtx(() => [
              ((__props.event.status === 'draft' && __props.event.trainer_id === __props.user.id) || (__props.event.status === 'draft' && __props.event.user_id === __props.user.id))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(DefaultButton, {
                      type: "primary",
                      onAction: _cache[2] || (_cache[2] = ($event: any) => (emitEventChange('in review')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("submit-event-for-approval")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              ((__props.event.status === 'approved' && __props.event.trainer_id === __props.user.id) || (__props.event.status === 'approved' && __props.event.user_id === __props.user.id))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(DefaultButton, {
                      type: "primary",
                      onAction: _cache[3] || (_cache[3] = ($event: any) => (emitEventChange('ready')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("make-training-event-go-live")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (__props.event.status === 'published')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(DefaultButton, {
                  type: "primary",
                  onAction: _cache[4] || (_cache[4] = ($event: any) => (emitEventChange('unpublished')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("unpublish-event")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(DefaultButton, {
                  type: "danger",
                  onAction: emitCancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("cancel-event")), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})